<template>
    <div>
        <sui-segment basic>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="upload"/>
                <sui-header-content>Actualización de catálogo SEPOMEX</sui-header-content>
            </h2>
            <br><br>
        </sui-segment>

        <div class="ui icon positive big message" v-if="processing && !failed">
            <i class="notched circle loading icon"></i>
            <div class="content">
                <div class="header">
                    Importación en proceso
                </div>
                <p>Una vez finalizada la importación recibirás una notificación por correo electrónico</p>
            </div>
        </div>

        <div class="ui icon negative big message" v-if="processing && failed">
            <i class="times icon"></i>
            <div class="content">
                <div class="header">
                    Importación fallida
                </div>
                <p>Hubo un problema al importar el archivo, te sugerimos contactar al administrador</p>
            </div>
        </div>

        <div class="ui warning message" v-if="!processing">
            <div class="header">Información importante</div>
            <ol is="sui-list">
                <li is="sui-list-item">
                    Se debe realizar la descarga del catálogo desde el sitio oficial de
                    <a
                        target="_blank"
                        href="https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/CodigoPostal_Exportar.aspx"
                        >Servicio Postal Mexicano</a
                    >
                </li>
                <li is="sui-list-item">Realizar la descarga en formato <b>EXCEL</b></li>
                <li is="sui-list-item">
                    Si se descarga un archivo <b>.zip</b>, hay que extraer el archivo.
                </li>
                <li is="sui-list-item">
                    Para la importación sólo se admiten archivos con extensión <b>.xlsx</b>.<br>
                    <b><em>(Debe realizar la conversión del archivo en caso de no ser así)</em></b>
                </li>
            </ol>
        </div>

        <sui-form v-if="!processing">
            <sui-form-field>
                <label>Archivo de sepomex a importar:</label>
                <sui-form-fields fields="two">
                    <sui-form-field>
                        <input
                            type="file"
                            name="file"
                            ref="file"
                            accept=".xlsx"
                            @change="handleFileUpload()"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <div class="ui primary button" @click="submitFile">Importar</div>
                    </sui-form-field>
                </sui-form-fields>
            </sui-form-field>
        </sui-form>
    </div>
</template>

<script>
import Mixins from '@/mixins/index.js'

export default {
    name: 'SepomexImporter',

    mixins: [ Mixins ],

    data () {
        return {
            baseUrl: process.env.VUE_APP_BASEPATH || '/',
            apiEndpoint: '/api/uploader/',
            file: '',
            fileName: '',
            processing: false
        }
    },

    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },

    methods: {
        handleFileUpload () {
            this.file = this.$refs.file.files[0]
        },

        async submitFile () {
            if (!this.file) {
                return this.$swal({
                    icon: 'error',
                    title: 'Ooppss',
                    html: `Selecciona el archivo con la información a importar`
                })
            }

            let loader = this.$loading.show()
            this.apiEndpoint = '/api/uploader/'
            let { file } = await this.processRecordUpload('uploadFile', { destination: 'sepomex', sepomexFile: this.file }, false, this.globalTokenSetter)
            loader.hide()
            if (file) {
                this.$swal({
                    icon: 'info',
                    title: 'Importante',
                    html: `Una vez finalizada la importación recibirás una notificación por correo electrónico`
                })
                this.processAction(
                    'import',
                    { file },
                    false,
                    false,
                    {},
                    'codigos_postales',
                    '/api/sepomex/',
                    this.globalTokenSetter,
                    false
                )
                this.processing = true
            }
        }
    }
}
</script>

<style scoped>
</style>
